import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getLevelArrayMetric as i } from "../index4.js";
import { getLevelArea as m } from "../level-metrics/index4.js";
const C = (e) => i(e, (o, t) => m(o, t, [r.Core, r.Corridor]));
export {
  C as getLevelArrayCoreAndCorridorArea
};
//# sourceMappingURL=index5.js.map
